enum PurchaseType {
  NotPurchasable = 'NotPurchasable',
  Reservable = 'Reservable',
  Purchasable = 'Purchasable'
}

export enum PurchaseTypeId {
  NotPurchasable,
  Reservable,
  Purchasable
}

export default PurchaseType;
